(function documentContainerSelectDirectiveDefinition() {

    'use strict';

    // esta directiva va a usar el mismo modulo de DocumentContainers,
    // por eso el component.json tiene como dependencia a la componente padre.
    angular.module('DocumentContainer')
           .directive('documentContainerSelect', ['config',
               function documentContainerSelectDirective(config) {

                   return {
                       restrict: 'E',
                       templateUrl: config.resourceUrl('/views/document-container/directive/select.html'),
                       scope: {
                           selectedContainers: '=ngModel',
                           name: '@',
                           placeholder: '@',
                           searchButtonClass: '@',
                           selectClass: '@',
                           allowEdit: '=',
                           onCanRemove: '&',
                           containerDetail: '@',
                           singleSelect: '&',
                           documentTypes: '='
                       },
                       controller: [
                            '$scope', '$element', '$attrs', '$uibModal', 'config', 'documentContainerService', 'errors',
                            function collapsableMenuController($scope, $element, $attrs, $modal, config, documentContainerService, errors) {

                                if (!$scope.containerDetail) {
                                    $scope.containerDetail = 'simple';
                                }

                                $scope.search = function () {
                                    var modalInstance = $modal.open({
                                        templateUrl: config.resourceUrl('/views/document-container/directive/select-list.html'),
                                        controller: 'DocumentContainerSelectModalController',
                                        size: 'lg',
                                        resolve: {
                                            info: function () {

                                                var selectedIds = {};

                                                if (angular.isArray($scope.selectedContainers)) {
                                                    angular.forEach($scope.selectedContainers, function (cont) {
                                                        selectedIds[cont.id] = true;
                                                    });
                                                } else if ($scope.selectedContainers) {
                                                    selectedIds[$scope.selectedContainers.id] = true;
                                                }

                                                return {
                                                    selected: selectedIds,
                                                };
                                            },
                                            documentTypes: function () {
                                                return $scope.documentTypes;
                                            }

                                        }
                                    });

                                    modalInstance.result.then(function (result) {
                                        if (result) {
                                            $scope.selectContainer(result);
                                        }
                                    });
                                };

                                $scope.selectContainer = function (item) {
                                    documentContainerService.getById(item.id, $scope.containerDetail)
                                       .then(function (container) {

                                           if ($scope.singleSelect()) {
                                               // deselecciono al anterior
                                               if ($scope.selectedContainers != null) {
                                                   $scope.removeContainer($scope.selectedContainers);
                                               }
                                               $scope.selectedContainers = container;
                                           } else {
                                               // lo agrego al modelo original
                                               $scope.selectedContainers.push(container);
                                           }

                                           $scope.$parent.$eval($attrs.onSelect, {
                                               $item: container,
                                               $container: container
                                           });

                                       }, function (result) {
                                           errors.showError(result);
                                       });
                                };

                                $scope.removeContainer = function (item, index, $event) {

                                    if ($scope.singleSelect()) {
                                        $scope.selectedContainers = null;
                                    } else {
                                        // lo remuevo del modelo
                                        $scope.selectedContainers.splice(index, 1);

                                        $scope.$parent.$eval($attrs.onRemove, { $item: item, $container: item });
                                    }

                                    if ($event) {
                                        $event.stopPropagation();
                                    }
                                };

                                $scope.canRemove = function (item) {

                                    if ($scope.singleSelect()) {
                                        return false;
                                    }

                                    var can = $scope.onCanRemove({ $item: item, $container: item });
                                    if (angular.isUndefined(can)) {
                                        return true;
                                    }
                                    return can;
                                };

                                if (angular.isUndefined($scope.allowEdit)) {
                                    $scope.allowEdit = true;
                                }
                            }
                       ]
                   };

               }]);

})();